import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RestService } from '../rest.service';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es';

@Component({
  selector: 'app-bingo',
  templateUrl: './bingo.component.html',
  styleUrls: ['./bingo.component.scss']
})
export class BingoComponent implements OnInit {

  // Botones
  btntotal = true;
  btnperiod = false;
  btnbingos = false;
  btntype = false;
  btndatos = false;
  btnproveedor = false;
  btndate = false;
  btnomperiod = '';
  btnomprov = '';
  btnomtype = 'bt';

  // Iconos mostrar y ocultar
  show = 'https://cdn1.iconfinder.com/data/icons/eyes-set/100/eye3-01-512.png';
  hide = 'https://cdn3.iconfinder.com/data/icons/show-and-hide-password/100/show_hide_password-08-512.png';

  bingos: any = [];
  campos_data: any = [];

  // FlatpickrOptions
  fdesde: any = '2018-09-17';
  fhasta: string = new Date().toISOString().slice(0, 10);

  fdesdeoptions = {
    locale: Spanish,
    onClose: (selectedDates, dateStr, instance) => this.fdesde = dateStr,
    altFormat: 'Y-m-d'
  };

  fhastaoptions = {
    locale: Spanish,
    onClose: (selectedDates, dateStr, instance) => this.fhasta = dateStr,
    altFormat: 'Y-m-d'
  };


  constructor(private rest: RestService) { }

  ngOnInit() {
    this.showPeriodo('anual');
  }

  // MOSTRAR REST TIPO_BINGO
  showPeriodo(periodo) {
    this.btnomperiod = periodo;
    this.getBingo(this.fdesde, this.fhasta, periodo, this.btnomtype);
  }

  // GET REST
  getBingo(fdesde, fhasta, periodo, bingo) {
    this.rest.getBingo(fdesde, fhasta, periodo, bingo)
      .subscribe((data) => {
        this.bingos = data;
        this.campos_data = Object.keys(this.bingos[0]['bingos'][0]['data'][0]);
      }, (error) => {
        console.log('Error', error);
      })
  }

  search() {
    this.getBingo(this.fdesde, this.fhasta, this.btnomperiod, this.btnomtype);
  }


  // Botones Auxiliares
  desplegarcontraer() {
    this.btnperiod = !this.btnperiod;
    this.btnbingos = !this.btnbingos;
    this.btntype = !this.btntype;
    this.btndatos = !this.btndatos;
    this.btnproveedor = !this.btnproveedor;
  }

  // GetValue of Proveedores
  getTodos(value) { this.btnomprov = value; }
  getPropiedad(value) { this.btnomprov = value; }
  getMetronia(value) { this.btnomprov = value; }
  getZitro(value) { this.btnomprov = value; }
  getFBM(value) { this.btnomprov = value; }
  getVaprel(value) { this.btnomprov = value; }

  // GetValue of Bingos Type
  getvalue(value) { this.btnomtype = value; this.search(); }

  // Ocultar y mostrar FrontEND
  hidebtnbingos() { this.btnbingos = !this.btnbingos; }
  hidebtnperiod() { this.btnperiod = !this.btnperiod; }
  hidebtntype($event) { this.btntype = !this.btntype; }
  hidebtndatos() { this.btndatos = !this.btndatos; }
  hidebtnproveedor() { this.btnproveedor = !this.btnproveedor; }

  hidesala(location) {
  location.activo = !location.activo;
  }

  activelocation(loc) { loc.activo = !loc.activo; }
  desplegarbtndate() { this.btndate = !this.btndate; }
  showhidebtn() { this.btntotal = !this.btntotal; }

}
